import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../translation/namespace';

export function ExternalLinkDescription() {
  const { t } = useTranslation(Namespace.phrases);
  return (
    <div hidden>
      <span id="opens-in-new-window">{t('linkOpensInNewWindow')}</span>
    </div>
  );
}
